import { notification } from 'antd';
import { groupBy, mapValues, orderBy, pick } from 'lodash';
import { call, put, select, takeLatest } from 'redux-saga/effects';
import {
  DEFAULT_DIAGRAM_GROUP_IDS,
  DEFAULT_ICON_GROUP_IDS,
  DEFAULT_SYSTEM_GROUP_IDS,
  DIAGRAM_VERSION,
  GCS_BUCKET,
  ICON_VERSION,
  SYSTEM_VERSION,
} from '../../store/mockyData';
import { getAxios } from '../../utils';
import {
  canvasSelector,
  setDiagramComponents,
  setFilterList,
  setIconsComponent,
  setLoadingForFetchAndAddComponent,
  setSystemComponents,
} from './reducer';
import * as types from './types';

const SYSTEMS = ['Common', 'Shapes', 'Charts', 'Devices', 'IOS', 'Android', 'Web', 'Avatar', 'Bootstrap', 'Ionic'];
const DIAGRAMS = ['Flowchart', 'Shapes', 'Container', 'Network'];
const ICONS = ['Action', 'Social', 'Notification', 'Navigation', 'Editor'];

export function* fetchSystems() {
  yield takeLatest(types.FETCH_SYSTEMS, function*() {
    yield put(setLoadingForFetchAndAddComponent(true));
    try {
      let res = [];
      const mappingData = yield call(
        getAxios,
        `https://storage.googleapis.com/${GCS_BUCKET}/built-in/systems/mapping/${SYSTEM_VERSION}.json`,
      );

      const groupedData = groupBy(mappingData, 'category');
      res = pick(groupedData, SYSTEMS);
      const sortArrayBySortProperty = (arr) => orderBy(arr, ['sort'], ['asc']);
      res = mapValues(res, sortArrayBySortProperty);

      yield put(setSystemComponents(res));

      const { filterList } = yield select(canvasSelector);
      yield put(setFilterList([...filterList, ...DEFAULT_SYSTEM_GROUP_IDS]));
    } catch (error) {
      console.error(error);
      notification.error({
        message: 'Get systems error!',
      });
    }
    yield put(setLoadingForFetchAndAddComponent(false));
  });
}

export function* fetchDiagrams() {
  yield takeLatest(types.FETCH_DIAGRAMS, function*() {
    yield put(setLoadingForFetchAndAddComponent(true));
    try {
      let res = [];

      const mappingData = yield call(
        getAxios,
        `https://storage.googleapis.com/${GCS_BUCKET}/built-in/diagrams/mapping/${DIAGRAM_VERSION}.json`,
      );

      const groupedData = groupBy(mappingData, 'category');
      res = pick(groupedData, DIAGRAMS);
      const sortArrayBySortProperty = (arr) => orderBy(arr, ['sort'], ['asc']);
      res = mapValues(res, sortArrayBySortProperty);

      for (let i = 0; i < Object.keys(res).length; i++) {
        let subRes = groupBy(res[Object.keys(res)[i]], 'subCategory');
        const sortArrayBySortProperty = (arr) => orderBy(arr, ['sort'], ['asc']);
        subRes = mapValues(subRes, sortArrayBySortProperty);
        if (Object.keys(subRes).length > 1) {
          res[Object.keys(res)[i]] = subRes;
        }
      }

      yield put(setDiagramComponents(res));

      const { filterList } = yield select(canvasSelector);
      yield put(setFilterList([...filterList, ...DEFAULT_DIAGRAM_GROUP_IDS]));
    } catch (error) {
      console.error(error);
      notification.error({
        message: 'Get diagrams error',
      });
    }
    yield put(setLoadingForFetchAndAddComponent(false));
  });
}

export function* fetchIcons() {
  yield takeLatest(types.FETCH_ICONS, function*() {
    yield put(setLoadingForFetchAndAddComponent(true));
    try {
      let res = [];
      const mappingData = yield call(
        getAxios,
        `https://storage.googleapis.com/${GCS_BUCKET}/built-in/icons/mapping/${ICON_VERSION}.json`,
      );

      const groupedData = groupBy(mappingData, 'category');
      res = pick(groupedData, ICONS);
      const sortArrayBySortProperty = (arr) => orderBy(arr, ['sort'], ['asc']);
      res = mapValues(res, sortArrayBySortProperty);

      yield put(setIconsComponent(res));

      const { filterList } = yield select(canvasSelector);
      yield put(setFilterList([...filterList, ...DEFAULT_ICON_GROUP_IDS]));
    } catch (error) {
      console.error(error);
      notification.error({
        message: 'Get icons error!',
      });
    }
    yield put(setLoadingForFetchAndAddComponent(false));
  });
}
